import get from 'lodash/get';

const aiRecommendationsState = (state) => state?.AiRecommendations;

export const getCarouselDataByStrategy = (strategy, pageName, state) => {
  const aiRecommendations = aiRecommendationsState(state);
  const data = get(aiRecommendations, 'data');
  return get(data, `${pageName}_${strategy}`);
};

export const getLoadingStateByStrategyAndPageName = (strategy, pageName, state) =>
  aiRecommendationsState(state)?.loading[`${pageName}_${strategy}`];
